import NewIcon from "@/Common/NewIcon/NewIcon";
import styled from "styled-components";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;
  @media screen and (max-width : 440px){
    margin-bottom : 1.5rem;
  }
`;

export const IconGroup=styled.div`
  position: absolute;
  top: 5px;
  right: 2px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  z-index: 2;
`

export const NewTagIcon = styled(NewIcon)`
  position: absolute;
  top: 8px;
  left: 8px;
  filter: drop-shadow(1px 1px 2px rgba(102, 102, 102, 0.1));
  z-index: 2;

`

export const EditableIcon = styled.img`
  width : 36px;
  height : 36px;
  filter: drop-shadow(1px 1px 2px rgba(102, 102, 102, 0.1));
`
export const PremiumIcon=styled.img`
  width : 39px;
  height : 39px;
  filter: drop-shadow(1px 1px 2px rgba(102, 102, 102, 0.1));
`

export const Thumbnail = styled.img`
  width :100%;
  height: 100%;
  object-fit: cover;
  display : flex;
  visibility : ${props => props.notThumbnailUrl ? "hidden" : "visible"};
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  opacity: ${props => props.isHide ? "0" : "1"};
  transition: 0.2s;
`;

export const PreviewVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const TitleHover = styled.div`
  position :absolute;
  bottom: 0;
  width : 100%;
  height : 30%;
  background:linear-gradient(to bottom, rgba(25,25,25,0), rgba(25,25,25,1));
  padding: 10px;
  display : flex;
  flex-direction: column;
  justify-content : flex-end;
  color : #fff;
  box-sizing: border-box;
  align-items : flex-end;
  visibility : hidden;
  pointer-events: none;
  z-index: 2;
`
export const ThumbnailWrap = styled.div`
  position : relative;
  width: ${props => props.width ? props.width : "340px"};
  height: ${props => props.height ? props.height : "190px"};
  background :${props => props.notThumbnailUrl ? "gray" : ""};
  &:hover{
    ${TitleHover}{
      visibility : visible;
    }
  }
  overflow: hidden;
 
`
export const Title = styled.div`
  font-size : 14px;
  font-weight: 500;
  color : #fff;
  text-align : left;
  word-break: break-all;
  width: 100%;
  margin-bottom: 4px;
`
export const Date = styled.div`
  font-size : 12px;
  color : #fff;
`